import { Infra } from '@getvim/vim-connect';

export const widgetId = Infra.Apps.Product.Eligibility;
